import * as PIXI from 'pixi.js';
import TransformComponent from '../Component/Transform';
import GameObject from '../GameObject/GameObject';
import RelativePositionComponent from '../Component/Render/RelativePosition';

export default class Graphics extends GameObject<PIXI.Graphics> {
    protected instantiateContainer(params: any): void {
        this.container = new PIXI.Graphics();
    }

    protected onCreate(params: any): void {
        this.addComponent(TransformComponent, params);

        if (params.relativePosition) {
            this.addComponent<RelativePositionComponent>(
                RelativePositionComponent,
                params
            );
        }
    }
}
